import BigMath from "./math";
import { ScaledAmount, UnitScale } from "./types";

/**
 * 印度计数体系单位 (Lakh, Crore)
 * 1 K = 1,000
 * 1 L = 100,000
 * 1 C = 10,000,000
 */
export const INDIAN_UNITS: UnitScale[] = [
    { symbol: "C", value: 10_000_000, decimalPlaces: 2 },
    { symbol: "L", value: 100_000, decimalPlaces: 2 },
    { symbol: "K", value: 1_000, decimalPlaces: 2 },
];

/**
 * 国际通用计数体系单位 (Million, Billion)
 * 1 K = 1,000
 * 1 M = 1,000,000
 * 1 B = 1,000,000,000
 * 1 T = 1,000,000,000,000
 */
export const INTERNATIONAL_UNITS: UnitScale[] = [
    { symbol: "T", value: 1_000_000_000_000, decimalPlaces: 2 },
    { symbol: "B", value: 1_000_000_000, decimalPlaces: 2 },
    { symbol: "M", value: 1_000_000, decimalPlaces: 2 },
    { symbol: "K", value: 1_000, decimalPlaces: 2 },
];

/**
 * 对金额应用单位缩放 logic
 * @param amount 原始金额
 * @param units 适用的单位体系配置
 * @returns 缩放后的金额对象 (包含数值、单位、推荐小数位)
 */
export function applyUnitScale(
    amount: number,
    units: UnitScale[],
): ScaledAmount {
    const absAmount = BigMath.abs( amount );

    for ( const unit of units ) {
        if ( BigMath.gte( absAmount, unit.value ) ) {
            return {
                value: BigMath.div( amount, unit.value ), // value keeps the sign
                unit: unit.symbol,
                decimalPlaces: unit.decimalPlaces,
            };
        }
    }

    return {
        value: amount,
        unit: undefined,
        decimalPlaces: 2,
    };
}
